const PIXEL_ID = '1648548090030181'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

/**
 * Injects the Meta Pixel exactly once and fires the initial PageView.
 * Safe to call on every mount.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) {
    window.fbq('track', 'PageView')
    return
  }

  const fbq: Fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue?.push(args)
    }
  } as Fbq

  window.fbq = fbq
  window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const first = document.getElementsByTagName('script')[0]
  first?.parentNode?.insertBefore(script, first)

  const noscript = document.createElement('noscript')
  const pixelImg = document.createElement('img')
  pixelImg.height = 1
  pixelImg.width = 1
  pixelImg.style.display = 'none'
  pixelImg.alt = ''
  pixelImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(pixelImg)
  document.body.appendChild(noscript)

  fbq('init', PIXEL_ID)
  fbq('track', 'PageView')
}

export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}
